export default {
  GOALS_DASHBOARD_PROGRESS_STATE_MANAGER: Symbol.for('GOALS_DASHBOARD_PROGRESS_STATE_MANAGER'),
};
